/* eslint-disable no-console */
import Api from '../api';
import { parseCurrencyInput } from '../conlicitaseg';
import { FormProcessData } from '../../store/modules/conlicitaseg_store/types';

export const uploadContractForExtraction = async (
  file: File,
  biddingId?: number,
): Promise<Partial<FormProcessData>> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    if (biddingId) {
      formData.append('bidding_id', String(biddingId));
    }

    const response = await Api.post('/conlicitaseg/insurance_quotes/extract_contract', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    const execucao = response.data?.execucao;
    if (!execucao) return {};

    const { contract_value, ...rest } = execucao;
    const mapped: Partial<FormProcessData> = { ...rest };
    if (typeof contract_value === 'string' && contract_value) {
      mapped.contract_value = parseCurrencyInput(contract_value);
    }

    return mapped;
  } catch (error) {
    console.error('Erro ao extrair dados do contrato:', error);
    return {};
  }
};

export const downloadFile = async (quoteId: number, type: string) => {
  try {
    if (!quoteId) {
      throw new Error('ID da cotação não fornecido');
    }
    const response = await Api.get('/conlicitaseg/insurance_quotes/download_file', {
      params: { id: quoteId, type },
      responseType: 'blob',
    });

    if (!response.data) {
      throw new Error('Dados do arquivo não encontrados');
    }

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${type}-${Date.now()}.pdf`);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'Download realizado com sucesso' };
  } catch (error) {
    console.error('Erro ao baixar arquivo:', error);
    throw error;
  }
};

export const sendInsuranceQuoteToEmail = async (quoteId: string, email: string) => {
  try {
    const response = await Api.post('/conlicitaseg/insurance_quotes/send_to_email', {
      quoteId,
      email,
    });

    return { success: true, message: 'E-mail enviado com sucesso', data: response.data };
  } catch (error) {
    console.error('Erro ao enviar e-mail:', error);
    throw error;
  }
};
